import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { generateRequestTimeLogHeader } from 'src/app/core/interceptors/log.interceptor';
import {
  ICalculateCreditsConsumptionByExternalId,
  ICalculateCreditsConsumptionResponse,
  TotalCredits
} from '../interfaces/credits-management.interface';

@Injectable({
  providedIn: 'root',
})
export class CreditsManagementService {
  constructor(private readonly httpClient: HttpClient) {}

  calculateConsumption(data: ICalculateCreditsConsumptionByExternalId) {
    return this.httpClient.post<ICalculateCreditsConsumptionResponse>(
      `${environment.externalUrls.bff}/company/calculate-consumption`,
      {
        ...data,
        companyId: data.externalId,
      }
    );
  }

  /**
   * `channelReferenceId` lets the BFF resolve the company the bot actually
   * charges (bot state), behind the `enable_credits_company_from_bot_state` toggle.
   */
  getCompanyCredits(companyId: string, channelReferenceId?: string) {
    return this.httpClient.get<TotalCredits>(
      `${environment.externalUrls.bff}/company/credits`,
      {
        params: channelReferenceId ? { companyId, channelReferenceId } : { companyId },
        headers: generateRequestTimeLogHeader(
          'get-company-credits-message-cost',
        ),
      },
    );
  }
}
